<template>
  <div class="container-table-user">
    <q-card>
      <q-card-section>
        <q-table
          :key="keyTable"
          data-cy="list-user"
          class="list-user"
          :title="title"
          :columns="columns"
          row-key="id"
          :data="data"
          :loading="isLoading"
          :pagination.sync="pagination"
          @request="onRequest"
          :filter="filter"
          :rows-per-page-options="[5, 7, 10, 15, 20, 25, 50]"
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th
                v-for="col in props.cols"
                :key="col.name"
                :props="props"
                v-show="!isOpen || (isOpen && !col.checkVisible)"
              >
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:top-right>
            <div v-if="enableAuthorize" style="margin-right: 44px">
              <q-btn
                data-cy="authorize-user"
                color="primary"
                label="Autorizar a nuevo usuario"
                @click="triggerAuthorize()"
              />
            </div>
            <div>
              <q-input
                dense
                debounce="2000"
                v-model="filter"
                outlined
                stack-label
                placeholder="Escriba para buscar"
                :disabled="isLoading ? true : false"
              >
                <template v-slot:append>
                  <q-icon name="search" />
                </template>
              </q-input>
            </div>
          </template>
          <template v-slot:body="props">
            <q-tr
              :props="props"
              @click="triggerEdit(props.row)"
              style="cursor: pointer"
              :class="{ selected: selectedRow == props.row.id }"
            >
              <q-td key="user" :props="props">
                <q-img
                  style="height: 24px; width: 24px"
                  :src="
                    require('@/assets/img/icon-action-account-circle-24-px.svg')
                  "
                />
                {{ props.row.name + " " + props.row.surNames }}
              </q-td>
              <q-td key="email" :props="props">
                {{ props.row.email }}
              </q-td>
              <q-td v-if="showUsername" key="username" :props="props">
                {{ props.row.userName }}
              </q-td>
              <q-td v-if="showCompany" key="empresa" :props="props">
                {{ assertMaxChars(props.row.attributes.company) }}
                <q-tooltip v-if="props.row.attributes.company.length > 40" anchor="center middle" self="center middle">
                    <strong>{{ props.row.attributes.company }}</strong>
                </q-tooltip>
              </q-td>
              <q-td v-if="showLocale" key="locale" :props="props">
                {{ fillLocale(props.row.attributes.locale) }}
              </q-td>
              <q-td v-if="showActiveButton" key="activo" :props="props">
                <q-toggle
                  data-cy="toggle-user-enabled"
                  color="primary"
                  v-model="props.row.enabled"
                  @input="saveValue(props.row)"
                  disable
                />
              </q-td>
              <q-td v-if="showEditButton" key="editar" :props="props">
                <q-icon
                  name="o_create"
                  style="color: #002f6c; font-size: 24px"
                  @click="triggerEdit(props.row)"
                />
              </q-td>
              <q-td v-if="showDeleteButton" key="eliminar" :props="props">
                <q-icon
                  data-cy="delete-user-icon"
                  name="o_delete"
                  style="color: #002f6c; font-size: 24px"
                  @click="triggerDelete(props.row)"
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
    </q-card>

    <DialogCreate
      v-if="enableAuthorize"
      v-model="showDialogauthorizeEntidad"
      title="Autorizar a nuevo usuario"
      labelSuccess="Autorizar"
      dataCy="create-user"
      @save="authorizeEntidad()"
    >
      <template slot="body">
        <div class="title-option text-center">
          Añada un nuevo usuario a la entidad buscándolo por apellidos y nombre o email
        </div>
        <div class="row q-col-gutter-md col-12">
          <div class="col-12">
            <SelectSearchBox
              placeholder="Nombre y apellidos"
              hint="Introduzca al menos 3 caracteres"
              optionValue="fullName"
              :optionValueItems="['fullName', 'email', 'userName', 'locale']"
              nameCypress="user-name"
              noOption="Sin resultados"
              :showNoOption="selectSearchBox.haveError ? false : true"
              :optionsSelect="selectSearchBox.userList"
              v-model="selectSearchBox.userSelected"
              @filterEvent="filterFnUsuarios"
              :isSearching="selectSearchBox.isSearching"
            />
          </div>
          <div class="col-12 text-center text-negative">
            {{ selectSearchBox.haveError ? selectSearchBox.haveError : "" }}
          </div>
        </div>
      </template>
    </DialogCreate>

    <DialogDelete
      v-if="showDeleteButton && desauthorizeUserEntidadSelected"
      v-model="showDialogDelete"
      dataCy="delete-user"
      :showIcon="true"
      :txtContainer="`¿Está seguro de eliminar al usuario ${desauthorizeUserEntidadSelected.name} ${desauthorizeUserEntidadSelected.surNames}?`"
      @save="desauthorizeEntidad()"
    />
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import SelectSearchBox from '@/shared/select-apisearch/components/Select.vue';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import DialogCreate from '@/shared/dialogs/create/DialogCreate.vue';
import { v4 as uuidv4 } from 'uuid';

import {
  QTable,
  QTd,
  QTr,
  QTh,
  QImg,
  QCard,
  QCardSection,
  QToggle
} from 'quasar';

export default {
  components: {
    QTable,
    QTd,
    QTr,
    QTh,
    QImg,
    QCard,
    QCardSection,
    QToggle,
    SelectSearchBox,
    DialogDelete,
    DialogCreate
  },
  mixins: [Message],
  props: {
    isopenSideBar: Boolean,
    title: {
      required: true,
      type: String,
      default: () => ''
    },
    enableAuthorize: {
      required: false,
      type: Boolean,
      default: () => true
    },
    showActiveButton: {
      required: false,
      type: Boolean,
      default: () => false
    },
    showEditButton: {
      required: false,
      type: Boolean,
      default: () => false
    },
    showDeleteButton: {
      required: false,
      type: Boolean,
      default: () => false
    },
    showUsername: {
      required: false,
      type: Boolean,
      default: () => false
    },
    showLocale: {
      required: false,
      type: Boolean,
      default: () => true
    },
    showCompany: {
      required: false,
      type: Boolean,
      default: () => true
    },
    requestUser: {
      required: true,
      type: Object,
      default: function () {
        return {
          list: '/User',
          count: '/User/Count',
          filter: '?'
        };
      }
    },
    dependecyEntidad: {
      required: false,
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      keyTable: null,
      entidadData: {},
      isOpen: this.isopenSideBar,
      isLoading: false,
      filter: '',
      filteredBy: '',
      dataFiltered: null,
      pagination: {
        sortBy: 'user',
        page: 1,
        descending: true,
        rowsPerPage: 20,
        rowsNumber: 10
      },
      columns: [
        {
          name: 'user',
          label: 'Nombre y apellidos',
          align: 'left',
          field: (row) => row.name + ' ' + row.surNames,
          sortable: true,
          style: 'width: 40%',
          checkVisible: false
        },
        {
          name: 'email',
          label: 'Email',
          align: 'left',
          field: 'email',
          sortable: true
        }
      ],
      data: [],
      selectedRow: null,
      showDialogauthorizeEntidad: false,
      showDialogDelete: false,
      desauthorizeUserEntidadSelected: null,
      selectSearchBox: {
        isSearching: false,
        userList: [],
        userSelected: null,
        haveError: null
      }
    };
  },
  beforeDestroy () {
    this.$eventHub.$off('refreshlistUsers');
  },
  async mounted () {
    await this.$eventHub.$on('refreshlistUsers', async () => {
      await this.onRequest({
        pagination: this.pagination,
        filter: this.filter ? this.filter : undefined
      });
    });
    if (this.showUsername) {
      this.columns.push({
        name: 'username',
        label: 'Username',
        align: 'left',
        field: 'userName',
        sortable: true,
        checkVisible: false
      });
    }
    if (this.showLocale) {
      this.columns.push({
        name: 'locale',
        label: 'Idioma',
        align: 'left',
        field: '',
        sortable: true,
        checkVisible: false
      });
    }
    if (this.showActiveButton) {
      this.columns.push({
        name: 'activo',
        label: 'Activado',
        align: 'center',
        field: 'enabled',
        sortable: true,
        checkVisible: false
      });
    }

    if (this.showEditButton) {
      this.columns.push({
        name: 'editar',
        label: 'Editar',
        align: 'center',
        field: '',
        sortable: false
      });
    }
    if (this.showCompany) {
      this.columns.push({
        name: 'empresa',
        label: 'Empresa',
        align: 'left',
        field: 'empresa',
        sortable: true,
        style: 'max-width: 300px'
      });
    }
    if (this.showDeleteButton) {
      this.columns.push({
        name: 'eliminar',
        label: 'Eliminar',
        align: 'center',
        field: '',
        sortable: false
      });
    }

    await this.onRequest({
      pagination: this.pagination,
      filter: undefined
    });
  },
  methods: {
    assertMaxChars (title) {
      let maxsize = 40;
      if (title.length >= maxsize) {
        return title.substring(0, maxsize) + '...';
      }
      return title;
    },
    canAuthorize: (d) => {
      return d ? Object.keys(d).length > 0 : false;
    },
    async _callData () {
      let data = null;
      this.isLoading = true;

      let request = {
        controller: `${this.requestUser.list}`
      };
      await this.$store
        .dispatch('PF/getSuit', request)
        .then(async (response) => {
          if (response) {
            data = response.data;
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.showError(err.message);
          this.isLoading = false;
        });
      return data;
    },
    async fetchFromServer (page, rowsPerPage, filter, sortBy, descending) {
      const lowerFilter = filter ? filter.toLowerCase() : '';
      if (this.data) this.data.slice();
      let data = null;
      data = await this._callData();
      if (filter) {
        data = data.filter((row) => {
          const keys = Object.keys(row);
          let dataValue = null;
          keys.forEach((i) => {
            const rowString = typeof row[i] === 'string';
            const rowName = rowString ? row[i].toLowerCase() : null;
            if (rowName) {
              if (rowName.includes(lowerFilter)) {
                dataValue = rowName.includes(lowerFilter);
              }
            }
          });
          return dataValue;
        });
      }

      if (sortBy) {
        const sortFn = descending
          ? (a, b) => (a.name > b.name ? -1 : a.name < b.name ? 1 : 0)
          : (a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
        data.sort(sortFn);
      }
      return data;
    },
    async onRequest (props) {
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      const filter = props.filter;
      const fetchCount = rowsPerPage === 0 ? this.pagination.rowsNumber : rowsPerPage;
      const startRow = (page - 1) * rowsPerPage;

      let returnedData = await this.fetchFromServer(
        startRow,
        rowsPerPage,
        filter,
        sortBy,
        descending
      );

      this.data.splice(0, this.data.length, ...returnedData);
      let numberRows = this.data.length;
      if (numberRows > 0) {
        this.pagination.rowsNumber = numberRows;
      }
      returnedData = returnedData.slice(startRow, startRow + fetchCount);
      this.data.splice(0, numberRows, ...returnedData);
      this.pagination.page = page;
      this.pagination.rowsPerPage = rowsPerPage;
      this.pagination.sortBy = sortBy;
      this.pagination.descending = descending;
      this.keyTable = uuidv4();
    },
    async saveValue (d) {
      let enabled = d.enabled;
      let id = d.id;
      let dataUser = await this._getUserData(id);

      let dataArray = {
        user: {
          email: dataUser.user.email,
          enabled: enabled,
          password: '',
          username: '-',
          name: dataUser.user.name,
          surNames: dataUser.user.surNames,
          attributes: {
            phone: dataUser.user.attributes.phone,
            locale: this.external.locale !== undefined ? this.external.locale.id : ''
          }
        }
      };

      let request = {
        controller: '/User/' + id,
        filter: {},
        body: dataArray
      };

      await this.$store
        .dispatch('PF/putSuit', request)
        .then((response) => {
          if (this.selectedRow === d.id) {
            this.$emit('openInfo', { data: d, open: false });
          }
        })
        .catch((err) => {
          this.showError(err.message);
        });
    },
    async _getUserData (id) {
      let returnData = null;

      let request = {
        controller: '/User/' + id
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then((response) => {
          returnData = response.data;
        })
        .catch((err) => {
          this.showError(err.message);
        });

      return returnData;
    },
    triggerAuthorize () {
      this.showDialogauthorizeEntidad = true;
      this.selectSearchBox.haveError = null;
    },
    triggerEdit (row) {
      this.selectedRow = row.id;
      this.$emit('openInfo', { data: row });
    },
    triggerDelete (row) {
      this.desauthorizeUserEntidadSelected = row;
      this.showDialogDelete = true;
    },
    editRow (props) {
      let idUsuario = props.row.id;

      this.$router.push({
        name: 'form_usuario',
        params: { idUser: idUsuario }
      });
    },
    async filterFnUsuarios (textToSearch, update, abort) {
      if (textToSearch.length > 3 && !this.selectSearchBox.isSearching) {
        this.userListFiltered = [];
        this.selectSearchBox.haveError = null;
        this.selectSearchBox.isSearching = true;

        let request = {
          controller: '/User/Search/' + textToSearch,
          opts: {
            errorHandleRedirect: Boolean(false)
          }
        };

        await this.$store
          .dispatch('PF/getSuit', request)
          .then((response) => {
            for (let i = 0; i < response.data.length; i++) {
              const fullName = `${response.data[i].surNames} , ${response.data[i].name}`;

              this.userListFiltered.push({
                id: response.data[i].id,
                email: response.data[i].email,
                fullName,
                userName: response.data[i].userName,
                entidades: response.data[i].entidades,
                locale: response.data[i].attributes.locale
              });

              this.selectSearchBox.isSearching = false;
            }
          })
          .catch((e) => {
            this.selectSearchBox.haveError = e.message;
            this.selectSearchBox.isSearching = false;
            abort();
          });
      }

      if (textToSearch === '') {
        update(() => {
          this.selectSearchBox.userList = this.userListFiltered;
        });
      } else if (this.userListFiltered.length === 0) {
        update(() => {
          this.selectSearchBox.userList = [];
        });
      } else {
        update(() => {
          this.selectSearchBox.userList = this.userListFiltered;
        });
      }
    },
    async authorizeEntidad () {
      let selectedUser = this.selectSearchBox?.userSelected;
      let idEntidad = this.dependecyEntidad?.id;
      if (!selectedUser || !idEntidad) return;

      let request = {
        controller: `/Entidad/${idEntidad}/User/${selectedUser.id}/entidad-relationship/`,
        filter: {}
      };

      await this.$store
        .dispatch('PF/postSuit', request)
        .then(async (response) => {
          this.showMessage('Usuario autorizado correctamente.');
          this.showDialogauthorizeEntidad = false;
          this.$eventHub.$emit('refreshlistUsers');
        })
        .catch((e) => {
          this.showError(e.message);
        });
    },
    async desauthorizeEntidad () {
      let selectedUser = this.desauthorizeUserEntidadSelected;
      let idEntidad = this.dependecyEntidad?.id;
      if (!selectedUser || !idEntidad) return;

      let request = {
        controller: `/Entidad/${idEntidad}/User/${selectedUser.id}/entidad-relationship/`,
        filter: {}
      };
      await this.$store
        .dispatch('PF/deleteSuit', request)
        .then(async (response) => {
          this.showMessage('Usuario desautorizado correctamente.');
          this.showDialogDelete = false;
          this.$eventHub.$emit('refreshlistUsers');
        })
        .catch((e) => {
          this.showError(e.message);
        });
    },
    fillLocale (locale) {
      switch (locale) {
        case 'es':
          return 'Español';
        case 'en':
          return 'Inglés';
        case 'ca':
          return 'Catalán';
        default:
          break;
      }
    }
  },
  watch: {
    isopenSideBar: {
      handler: function () {
        this.isOpen = this.isopenSideBar;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-table-user {
  &:deep() {
    .q-table__card {
      box-shadow: none;
    }
    .q-card__section--vert {
      padding: 0 !important;
    }
  }
}
</style>
